var app = angular.module("leonardo");

var ChangePasswordDialog = function($scope, $state, $http, ngDialog, ConfigThemeService, FormErrorsService) {
  $scope.onboarding = $state.current.onboarding ? true : false;
  $scope.user = $scope.ngDialogData.user;
  $scope.user.password = '';
  $scope.user.confirm_password = '';
  $scope.admin = $scope.ngDialogData.admin;
  $scope.error_old_password = false;
  $scope.error_password = false;
  $scope.error_confrim_password = false;

  $scope.errorPassword = function() {
    return ($scope.user.password !== $scope.user.confirm_password);
  };

  $scope.clearError = function() {
    $scope.error_old_password = false;
    $scope.error_password = false;
  };

  $scope.confirm = function() {
    $scope.error = false;
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    if ($scope.errorPassword()) return;
    var uri = '/api/2.0/users/' + $scope.user.id + '/change-password/';
    var url =  ConfigThemeService.generateURL(uri);
    $http.post(url, $scope.user).then(function() {
      $scope.closeThisDialog();
      ngDialog.open({
        template: 'views/templates/dialog/account-user/change-password-success.html'
      })
    }).catch(function(error) {
      if(error.old_password !== undefined) {
        $scope.error_old_password = error.old_password[0];
      }
      else {
        $scope.error_old_password = null;
      }
      if(error.password !== undefined) {
        $scope.error_password = true;
      }
      else {
        $scope.error_password = false;
      }
    });
  }
};

app.controller('ChangePasswordDialog', ['$scope', '$state', '$http', 'ngDialog', 'ConfigThemeService', 'FormErrorsService', ChangePasswordDialog]);
